import cls from "classname"

import KpiTab from "../../../../Components/KpiTabs/KpiTab"

import kpiTabStyles from "../../../../Components/KpiTabs/kpiTabs.module.less"
import styles from "./kpiStrip.module.less"

// A card's KPIs (DAA-1-21): one strip of equal tiles split by hairlines, no frame, fill or hover of
// their own — the platform KPI tabs drawn as read-only stats. Each tile is a KpiTab `tab`:
// { key, label, value, prefix, suffix, decimals, unit, secondary, badge, note }; `value` null reads
// "-". `note` sits beside the value, `secondary` follows the badge in its row.
const KpiStrip = ({ tiles, className }) => (
  <div
    className={cls(kpiTabStyles.tabs, styles.strip, className)}
    style={{ "--kpi-cols": tiles.length }}
  >
    {tiles.map((tile) => (
      <KpiTab key={tile.key} tab={tile} readOnly className={styles.tile} />
    ))}
  </div>
)

export default KpiStrip
